export const countryCodeList = [
  '86',
  '886',
  '852',
  '853',
  '93',
  '355',
  '213',
  '1',
  '376',
  '244',
  '54',
  '374',
  '297',
  '247',
  '61',
  '43',
  '994',
  '973',
  '880',
  '375',
  '32',
  '501',
  '229',
  '975',
  '591',
  '387',
  '267',
  '55',
  '246',
  '673',
  '359',
  '226',
  '257',
  '855',
  '237',
  '238',
  '599',
  '236',
  '235',
  '56',
  '57',
  '269',
  '242',
  '243',
  '682',
  '506',
  '385',
  '53',
  '357',
  '420',
  '225',
  '45',
  '253',
  '593',
  '20',
  '503',
  '240',
  '291',
  '372',
  '268',
  '251',
  '500',
  '298',
  '679',
  '358',
  '33',
  '594',
  '689',
  '241',
  '220',
  '995',
  '49',
  '233',
  '350',
  '30',
  '299',
  '590',
  '502',
  '44',
  '224',
  '245',
  '592',
  '509',
  '504',
  '36',
  '354',
  '91',
  '62',
  '98',
  '964',
  '353',
  '972',
  '39',
  '81',
  '962',
  '7',
  '254',
  '686',
  '383',
  '965',
  '996',
  '856',
  '371',
  '961',
  '266',
  '231',
  '218',
  '423',
  '370',
  '352',
  '261',
  '265',
  '60',
  '960',
  '223',
  '356',
  '692',
  '596',
  '222',
  '230',
  '262',
  '52',
  '691',
  '373',
  '377',
  '976',
  '382',
  '212',
  '258',
  '95',
  '264',
  '674',
  '977',
  '31',
  '687',
  '64',
  '505',
  '227',
  '234',
  '683',
  '672',
  '850',
  '389',
  '47',
  '968',
  '92',
  '680',
  '970',
  '507',
  '675',
  '595',
  '51',
  '63',
  '48',
  '351',
  '974',
  '40',
  '250',
  '685',
  '378',
  '966',
  '221',
  '381',
  '248',
  '232',
  '65',
  '421',
  '386',
  '677',
  '252',
  '27',
  '82',
  '211',
  '34',
  '94',
  '290',
  '508',
  '249',
  '597',
  '46',
  '41',
  '963',
  '239',
  '992',
  '255',
  '66',
  '670',
  '228',
  '690',
  '676',
  '216',
  '90',
  '993',
  '688',
  '256',
  '380',
  '971',
  '598',
  '998',
  '678',
  '58',
  '84',
  '681',
  '967',
  '260',
  '263',
]
